/**
 * Admin event dan bendahara hanya memegang SATU kejuaraan, jadi pilihan
 * turnamen di halaman mana pun tidak ada gunanya bagi mereka.
 *
 * Daripada menyunting puluhan formulir satu per satu (dan pasti ada yang
 * terlewat ketika halaman baru ditambahkan), satu pengamat DOM menangani
 * semuanya: setiap <select> yang memuat opsi bernilai id kejuaraan si
 * pengguna otomatis dipilihkan lalu disembunyikan beserta labelnya.
 *
 * Ini murni tampilan. Kunci yang sebenarnya ada di server (middleware
 * kunci.turnamen) — mengakali halaman tidak membuka kejuaraan lain.
 */
import { grupPengguna, GRUP } from './peran';

const PENANDA = 'data-turnamen-tunggal';

function idTerkunci() {
  if (![GRUP.ADMIN_EVENT, GRUP.BENDAHARA].includes(grupPengguna())) return null;
  try {
    const id = JSON.parse(localStorage.getItem('user') || '{}').tournament_id;
    return id ? String(id) : null;
  } catch (e) {
    return null;
  }
}

function pembungkus(select) {
  // Kolom grid yang hanya berisi pilihan ini ikut disembunyikan supaya
  // tidak menyisakan ruang kosong; selain itu cukup label/field-nya.
  const kolom = select.closest('[class*="col-"]');
  if (kolom && kolom.querySelectorAll('select, input, textarea').length === 1) return kolom;
  return select.closest('.ui-field, .form-group, .mb-3, label') || select;
}

const KATA_TURNAMEN = /turnamen|acara|tournament|kejuaraan|event/i;

/**
 * Hanya pilihan TURNAMEN yang disentuh. Pilihan lain (kontingen, kelas)
 * bisa saja kebetulan memuat angka id yang sama.
 */
function pilihanTurnamen(select) {
  const pertama = select.options[0]?.textContent || '';
  const label = select.id && document.querySelector(`label[for="${select.id}"]`)?.textContent;
  const sekitar = select.closest('.ui-field, .form-group, .mb-3, label, [class*="col-"]')
    ?.querySelector('label, .ui-label, .form-label')?.textContent || '';
  return KATA_TURNAMEN.test(pertama) || KATA_TURNAMEN.test(label || '') || KATA_TURNAMEN.test(sekitar);
}

function tangani(select, id) {
  const opsi = [...select.options].find((o) => o.value === id);
  if (!opsi || !pilihanTurnamen(select)) return;

  if (select.value !== id) {
    select.value = id;
    // v-model pada <select> mendengarkan "change".
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  const bungkus = pembungkus(select);
  if (!bungkus.hasAttribute(PENANDA)) {
    bungkus.setAttribute(PENANDA, '');
    // !important: beberapa pilihan memakai kelas Bootstrap d-inline-block yang juga !important.
    bungkus.style.setProperty('display', 'none', 'important');
  }
}

export function pasangTurnamenTunggal() {
  let terjadwal = false;

  const pindai = () => {
    terjadwal = false;
    const id = idTerkunci();
    if (!id) return;
    document.querySelectorAll('select').forEach((s) => tangani(s, id));
  };

  const jadwalkan = () => {
    if (terjadwal) return;
    terjadwal = true;
    requestAnimationFrame(pindai);
  };

  new MutationObserver(jadwalkan).observe(document.body, { childList: true, subtree: true });
  jadwalkan();
}
